import type { StaffRole, User } from '../../types/user';

/** The roles that hand the entry instructions out: the event's admins and its desk. */
const ROLES: StaffRole[] = ['admin', 'member_manager'];

/**
 * Whether `user` may download a competition's entry instructions: a confirmed
 * admin or member manager of it — the circuit's or the hosting gym's included,
 * which `user.staff` already lists against the competition's slug (see
 * Staff.effective_for on the server).
 *
 * One rule for the page and for the button that leads to it, so the button is
 * never offered to somebody the page would turn away.
 */
export function canDownloadInstructions(user: Pick<User, 'staff'> | null | undefined, competitionSlug: string) {
  const staff = user?.staff?.find((entry) => entry.gym_slug === competitionSlug);
  return staff?.status === 'confirmed' && staff.staff_roles.some((role) => ROLES.includes(role));
}
